import { render, staticRenderFns } from "./RedlightAccusationTime.vue?vue&type=template&id=37893b06&"
import script from "./RedlightAccusationTime.vue?vue&type=script&lang=js&"
export * from "./RedlightAccusationTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports